module.exports = __webpack_public_path__ + "img/lifestyle_circle_frame_04.26af1b06.png";